module.exports = __webpack_public_path__ + "img/1527058652.c312d267.jpg";